import '@splidejs/splide/css';
import Splide from '@splidejs/splide';


const initializeBlock = function( $block ){
  // console.log($block);
  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  // console.log('Initializing slider block:', $block);

  let slider;
  let isGridContainerMobileSlider = $block.classList.contains('grid-container') && $block.classList.contains('mobile-slider');
  const isAdmin = document.body.classList.contains('wp-admin');

  if($block.classList.contains('slider_block')){
    // console.log('setting slider block slider');
    slider = $block.querySelector('.slider_block__slider');
  }
  else if(isGridContainerMobileSlider){
    // console.log('setting grid container slider');
    slider = $block;
  }

  if(!slider){ 
    return; 
  }

  if(slider.splide){
    // If the slider already exists, destroy it first
    slider.splide.destroy();
    slider.splide = null;
  }

  // For slides that don't already have the .splide__slide class, add it
  const slides = slider.querySelectorAll('.splide__list > *');
  Array.prototype.forEach.call(slides, function(el, i){
    if(!el.classList.contains('splide__slide')){
      el.classList.add('splide__slide');
    }
  });

  // Set up Args (rewritte for grid container mobile slider)
  const arrowPath = 'M22.5 7.5 L35 20 M35 20 L22.5 32.5 M35 20 H5';

  let args = { 
    gap: '3rem',
    drag: isAdmin ? false : true,
    arrowPath: arrowPath,
    breakpoints: {
      1920: {
        gap : '2rem'
      },
      1200: {}, // Ready for population
      990: {
        gap : '1.2rem'
      },
      767: {} // Ready for population
    }
  };

  if(isGridContainerMobileSlider){
    const mobilePerPage = $block.getAttribute('data-slides-per-page-mobile') || 1;
    const tabletPerPage = $block.getAttribute('data-slides-per-page-tablet') || 1;

    args.perPage = parseInt(mobilePerPage);
    args.mediaQuery = 'min';
    args.breakpoints = {
      640: {
        perPage: parseInt(tabletPerPage),
      },
      991: {
        destroy: true,
      }
    }
  }
  else {
    if($block.classList.contains('slider-auto-start')){
      args.autoplay = true;
      args.interval = $block.getAttribute('data-td-speed') || 3000;
      args.pauseOnHover = false;
    }
  
    if($block.getAttribute('data-transition-type') === 'fade'){
      args.type = 'fade';
      args.rewind = true;
      args.speed = 1400;
    }
  
    // Set Per Page Args
    const defaultPerPageDesktop = $block.classList.contains('slider-type-card') ? 4 : 1;
    const defaultPerPageLaptop = $block.classList.contains('slider-type-card') ? 3 : 1;
    const defaultPerPageTablet = $block.classList.contains('slider-type-card') ? 2 : 1;
    const defaultPerPageMobile = 1;
    const slidesPerPageDesktop = parseInt($block.getAttribute('data-slides-per-page-desktop')) || defaultPerPageDesktop;
    // For laptop, fallback to a set desktop value if no laptop value is set
    const slidesPerPageLaptop = parseInt($block.getAttribute('data-slides-per-page-laptop')) ? parseInt($block.getAttribute('data-slides-per-page-laptop')) : parseInt($block.getAttribute('data-slides-per-page-desktop')) || defaultPerPageLaptop;
    const slidesPerPageTablet = parseInt($block.getAttribute('data-slides-per-page-tablet')) || defaultPerPageTablet;
    const slidesPerPageMobile = parseInt($block.getAttribute('data-slides-per-page-mobile')) || defaultPerPageMobile;
    args.perPage = slidesPerPageDesktop;
    args.breakpoints['1920'].perPage = slidesPerPageLaptop;
    args.breakpoints['1200'].perPage = slidesPerPageTablet;
    args.breakpoints['767'].perPage = slidesPerPageMobile;
  
    // Set Slides Per Move if required
    if($block.classList.contains('match-slides-per-move')){
      args.perMove = args.perPage;
      args.breakpoints['1920'].perMove = args.breakpoints['1920'].perPage;
      args.breakpoints['1200'].perMove = args.breakpoints['1200'].perPage;
      args.breakpoints['767'].perMove = args.breakpoints['767'].perPage;
    }
    else {
      args.perMove = 1;
    }
  }

  // Slider UI Options
  if($block.classList.contains('no-pagination')){
    args.pagination = false;
  } else if($block.classList.contains('has-pagination')){
    args.pagination = true;
  }
  if($block.classList.contains('has-arrows')){
    args.arrows = true;
  } else if($block.classList.contains('no-arrows')){
    args.arrows = false;
  }

  if(slider){
    // Create the slider
    slider.splide = new Splide(slider, args); 
    
    let currentSlideIndex = 0;

    // Update navigation count / progess bar
    slider.splide.on( 'move mounted resized', (newIndex) => {
      const sliderCountWrapper = slider.querySelector('.slider_block__slide-count');
      const slideCountEl = slider.querySelector('.slider_block__slide-count .current-slide');
      const totalSlidesEl = slider.querySelector('.slider_block__slide-count .total-slides');

      if( !$block.classList.contains( 'has-slide-count' ) || !slideCountEl || !totalSlidesEl || !sliderCountWrapper ) {
        return;
      }

      const {Slides} = slider.splide.Components;
      
      let current = (newIndex ?? 0);
      
      // Adjust current slide number when multiple slides are visible
      let lastVisible = current + (slider.splide.options.perPage ?? 0);
      if(Slides.getLength() < lastVisible){
        lastVisible = Slides.getLength();
      }

      let slideCountText = current < 11 ? '0' : '';
      slideCountText += current + 1;

      if(lastVisible > (current + 1)){
        slideCountText += '–';
        slideCountText += lastVisible < 10 ? '0' : '';
        slideCountText += lastVisible;
      }
      
      slideCountEl.textContent = slideCountText;
      totalSlidesEl.textContent = Slides.getLength() < 10 ? '0' + Slides.getLength() : Slides.getLength();

      if(!sliderCountWrapper.classList.contains('is-visible')){ 
        sliderCountWrapper.classList.add('is-visible');
        sliderCountWrapper.setAttribute( 'aria-hidden', 'false' );
      }
    });

    // Disable arrows at start and end
    const navWrap = slider.querySelector('.splide__arrows');
    if(!!navWrap){
      slider.splide.on('move', (newIndex) => {
        if(args.rewind || args.rewindByDrag){ return; }
        
        const leftArrow = slider.querySelector('.splide__arrow--prev');
        const rightArrow = slider.querySelector('.splide__arrow--next');

        if(newIndex == 0 && !!leftArrow){
          leftArrow.disabled = true;
        }
        else if(!!leftArrow && leftArrow.disabled){
          leftArrow.disabled = false;
        }
        
        if(newIndex > (slider.splide.length - 1 - slider.splide.options.perPage) && !!rightArrow){
          rightArrow.disabled = true;
        }
        else if(!!rightArrow && rightArrow.disabled){
          rightArrow.disabled = false;
        }
      });
    }

    // Ensure active class on new slide is added on move, rather than after move
    slider.splide.on('move', (newIndex) => {
      currentSlideIndex = newIndex;
      
      const allSlides = slider.querySelectorAll('.splide__slide');
      Array.prototype.forEach.call(allSlides, function(el, i){
        el.classList.remove('is-active');
        el.classList.remove('is-visible');
        
        // Add visible class to slides in view
        if(i >= newIndex && i < (newIndex + slider.splide.options.perPage)){
          el.classList.add('is-visible');
        }
        // Add active class to the current slide
        if(i == newIndex){
          el.classList.add('is-active');
        }
      });
    });
    
    // Mount the slider
    slider.splide.mount();

    // if there's a map, get it's height and set a css property on the slider block
    const mapWrapper = $block.querySelector('.slider_block__map');
    if(!!mapWrapper){
      const setMapHeight = () => {
        const height = mapWrapper.clientHeight;
        $block.style.setProperty('--slider-map-height', height + 'px');
      }
      setMapHeight();

      let mapDebouncer
      window.addEventListener('resize', () => {
        clearTimeout( mapDebouncer );
        mapDebouncer = setTimeout( () => {
          setMapHeight();
        }, 50 );
      });
    }
  }
}

const AdjustMobileGridSliderMarkup = function( $block ){
  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  // Add splide elements
  if(!$block.classList.contains('splide')){
    const inner = $block.querySelector('.grid-container_wrapper');
    $block.classList.add('splide');

    const splideTrack = document.createElement('div');
    splideTrack.classList.add('splide__track');

    inner.classList.add('splide__list');
    inner.childNodes.forEach(child => {
      if(child.nodeType === Node.ELEMENT_NODE){
        child.classList.add('splide__slide');
      }
    });

    splideTrack.appendChild(inner);
    $block.appendChild(splideTrack);

    // If it has the class .has-arrows, add a div for .splide__arrows
    if($block.classList.contains('has-arrows')){
      const arrowsDiv = document.createElement('div');
      arrowsDiv.classList.add('splide__arrows');
      $block.appendChild(arrowsDiv);
    }
  }

}


// Initialize the slider on the front end only
export const initializeSlider = function(){
  // Grid Container Mobile Sliders
  const gridMobileSliders = document.querySelectorAll('.grid-container.mobile-slider');
  Array.prototype.forEach.call(gridMobileSliders, function(el, i){
    AdjustMobileGridSliderMarkup(el);
  });

  const sliders = document.querySelectorAll('.slider_block, .grid-container.mobile-slider, .lwir');
  Array.prototype.forEach.call(sliders, function(el, i){
    initializeBlock(el);
  });
};


// Initialize the slider in the editor
export const initializeSliderEditor = () => {
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=slider', ( $block ) => {
      const slider = $block[0].querySelector('.slider_block');
      if(!slider) return;
      initializeBlock( slider );
    });
  }
}